import { render, staticRenderFns } from "./ProductAdditionalInfo.vue?vue&type=template&id=621bf1b2"
import script from "./ProductAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./ProductAdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./ProductAdditionalInfo.vue?vue&type=style&index=0&id=621bf1b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports